<template>
  <i :class="['material-icons', `md-${size}`, `rotate-${rotate}`]" :style="{ '--size': `${size}px` }">
    {{ name }}
  </i>
</template>

<script lang="ts">
// https://material.io/icons/
import { defineComponent } from "vue";
export default defineComponent({
  name: "component-icon",
  props: {
    name: { type: String, required: true },
    size: {
      type: Number,
      required: false,
      default: 24
    },
    rotate: {
      type: Number,
      required: false,
      default: 0,
      validator: (value: number) => [0, 90, 180, 270].includes(value)
    }
  }
});
</script>

<style lang="scss" scoped>
$size: var(--size);

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px; /* Preferred icon size */
  font-size: $size;
  width: calc(#{$size} + 2px); // for overflow:hidden
  height: $size;
  display: inline-block;
  overflow: hidden;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;
  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;
  /* Support for IE. */
  font-feature-settings: "liga";

  &.rotate-0 {
    transform: rotate(0deg);
  }
  &.rotate-90 {
    transform: rotate(90deg);
  }
  &.rotate-180 {
    transform: rotate(180deg);
  }
  &.rotate-270 {
    transform: rotate(270deg);
  }
}
</style>
